import React from "react";

type Props = React.HTMLAttributes<HTMLDivElement>;

export function Container({ className = "", ...props }: Props) {
  const base =
    "mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8";

  return (
    <div
      className={className ? `${base} ${className}` : base}
      {...props}
    />
  );
}

